export default function ToNumber(num) {
  return num ? Number(num) : null;
}
